module.exports = __webpack_public_path__ + "static/media/Circo2024_04.e81ccba6.webp";